import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { MessageBoxModalComponent } from '../components/messageBoxModal.component'

export interface MessageBoxOptions {
  text?: string
  title?: string
  inputType?: string
  prompt?: string
  value?: string
  positive?: string
  negative?: string
  danger?: boolean
  progress?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-type-alias
export type MessageBox = Promise<MessageBoxOptions> & {
  close: () => void
}

@Injectable({ providedIn: 'root' })
export class MessageBoxService {
  constructor (
    private translate: TranslateService,
    private ngbModal: NgbModal,
  ) { }

  show (options: MessageBoxOptions): MessageBox {
    const modal = this.ngbModal.open(MessageBoxModalComponent)
    modal.componentInstance.options = options
    const p = modal.result
    p['close'] = () => modal.dismiss()
    return p as MessageBox
  }

  prompt (options: MessageBoxOptions): MessageBox {
    return this.show({
      value: '',
      positive: this.translate.instant('OK'),
      negative: this.translate.instant('Cancel'),
      ...options,
    })
  }

  deletePrompt (objectType: string, objectName: string): MessageBox {
    let text = ''
    if (objectName) {
      text = this.translate.instant('Delete {objectType} "{objectName}"?', {
        objectType, objectName,
      })
    } else {
      text = this.translate.instant('Delete this {objectType}?', { objectType })
    }
    return this.show({
      text,
      title: this.translate.instant('Delete'),
      positive: this.translate.instant('Delete'),
      negative: this.translate.instant('Keep'),
      danger: true,
    })
  }
}
